import { GenericFieldType } from '../types/ContactForm';

export const GENERIC_FIELD_OPTIONS: { value: GenericFieldType; label: string }[] = [
    { value: 'artikelnummer', label: 'Artikelnummer' },
    { value: 'artikelname', label: 'Artikelname' },
    { value: 'artikelpreis', label: 'Artikelpreis' },
    { value: 'kategorie', label: 'Kategorie' },
    { value: 'hersteller', label: 'Hersteller' },
    { value: 'gtin', label: 'GTIN' },
    { value: 'sprache', label: 'Aktuelle Sprache' },
    { value: 'kundengruppe', label: 'Kundengruppe' },
    { value: 'uvp', label: 'UVP' },
    { value: 'shop-url', label: 'Aktuelle URL' },
];
